export function format(str, item) {
  return str.replace(/{(\w+)}/g, function (match, name) {
    return typeof item[name] !== "undefined" ? item[name] : match;
  });
}
